import { Box, IconButton, Stack, Button, Typography } from '@mui/material';
const ImagingUploadSection = ({
  title,
  previews,
  setPreviews,
  maxImages = 4,
  onUpload,
}: {
  title: string;
  previews: string[];
  setPreviews: (val: string[]) => void;
  maxImages?: number;
  onUpload?: (file: File) => Promise<string>;
}) => {
  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    if (onUpload) {
      // Upload mode
      for (const file of files) {
        if (previews.length >= maxImages) break;
        try {
          const url = await onUpload(file);
          setPreviews([...previews, url]); // Update state directly (Note: this might race condition if not careful, but simpler for now)
          // Better: accumulate and set once or use functional update
        } catch (err) {
          console.error('Upload failed', err);
        }
      }
      // Actually, let's do it properly
      const newUrls: string[] = [];
      for (const file of files) {
        try {
          const url = await onUpload(file);
          newUrls.push(url);
        } catch (err) {
          console.error('Upload failed for file', file.name, err);
        }
      }
      if (newUrls.length > 0) {
        setPreviews([...previews, ...newUrls].slice(0, maxImages));
      }
    } else {
      // Base64 mode (legacy)
      const newImages: string[] = [];
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          newImages.push(reader.result as string);

          if (newImages.length === files.length) {
            const updated = [...previews, ...newImages].slice(0, maxImages);
            setPreviews(updated);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const removeImage = (index: number) => {
    const updated = previews.filter((_, i) => i !== index);
    setPreviews(updated);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">{title}</Typography>

      {/* Upload Button */}
      <Button
        data-lock-hide
        variant="contained"
        component="label"
        sx={{ mt: 1 }}
        size="small"
      >
        Upload Images
        <input
          hidden
          multiple
          accept="image/*"
          type="file"
          onChange={handleUpload}
        />
      </Button>

      {/* Image Grid */}
      <Stack direction="row" spacing={2} sx={{ mt: 2 }} flexWrap="wrap">
        {previews.map((src, i) => (
          <Box
            key={i}
            sx={{
              width: 120,
              height: 90,
              borderRadius: 1,
              border: '1px solid #ccc',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <img
              src={src}
              alt=""
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              referrerPolicy="no-referrer"
            />

            <IconButton
              data-lock-hide
              size="small"
              sx={{
                position: 'absolute',
                top: 2,
                right: 2,
                background: 'rgba(0,0,0,0.5)',
                color: 'white',
              }}
              onClick={() => removeImage(i)}
            >
              ✕
            </IconButton>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ImagingUploadSection;
